module.exports = __webpack_public_path__ + "static/media/closePopUp.a708bbe6.svg";